import React, { useContext, useEffect } from 'react';
import { Drawer, Button, Col, Row, Typography } from 'antd';
import Cookies from 'js-cookie';
import { ThemeContext } from '../Context/ThemeContext';
import { ProfileContext } from '../Context/ProfileContext';
import WelcomeCard from '../Card/WelcomeCard';

const { Text } = Typography;
const HelpCenter = (props) => {
  const { helpCenterVisibility, closeHelpCenter } = useContext(ProfileContext);
  Cookies.set('foo', 'bar');

  const { theme } = useContext(ThemeContext);
  return (
    <div>
      <Drawer
        width='100%'
        onClose={closeHelpCenter}
        visible={helpCenterVisibility}
        placement='right'
        headerStyle={{ background: theme.drawer.bg }}
        bodyStyle={{ background: theme.drawer.bg }}
        footerStyle={{ background: theme.drawer.bg }}
        footer={
          <div
            style={{
              textAlign: 'right',
            }}
          >
            <Button onClick={closeHelpCenter} style={{ marginRight: 8 }}>
              Close
            </Button>
          </div>
        }
      >
        <Row>
          <Col xs={0} sm={0} md={4} lg={6} />
          <Col xs={24} sm={24} md={16} lg={12}>
            <WelcomeCard />
          </Col>
          <Col xs={0} sm={0} md={4} lg={6} />
        </Row>
      </Drawer>
    </div>
  );
};

export default HelpCenter;
